export default __webpack_public_path__ + "static/media/1617 knife block B side.e8e7e51d.png";